export default __webpack_public_path__ + "static/flyer-963b8b6e9395153fe278a7e3fbfe14cb.jpg";